import React from 'react';
import cn from 'classnames';
import Icon from 'components/Icon';
import { getAvailableDevices } from 'helpers/devices';

const DeviceToggler = ({ active, onChange }) =>
  getAvailableDevices().map((device, key) => (
    <button
      className={cn('btn btn_devices', device, {
        'btn_devices-active': active === device,
      })}
      onClick={() => onChange(device)}
      key={key}
    >
      <Icon className="icon" icon={device} />
    </button>
  ));

export default DeviceToggler;
